export function openAssetPicker(id, position, size, type, currentAsset, onPickerClose, onPickAsset) {
    return { 
        type: 'AP_OPEN', 
        payload: {
            identifier: id,
            pos: position,
            pickerSize: size,
            assetType: type,
            curAsset: currentAsset,
            handlePickerClose: onPickerClose, 
            handlePickAsset: onPickAsset
        } 
    };
}

export function setTransformation(size, pos) {
    return { 
        type: 'AP_SET_TRANSFORMATION', 
        payload: {
            size: size,
            position: pos
        } 
    };
}

export function closeAssetPicker() {
    return { type: 'AP_CLOSE' };
}

export function setCurrentAssetPickerItem(currentAsset) {
    return { type: 'AP_SET_CURRENT_ITEM', payload: currentAsset };
}
